import { Type } from 'class-transformer'

import { Pallet } from './Pallet'
import { FreightOrder } from './FreightOrder'

export class FreightOrderPallet {
  get guid(): string {
    return this.pallet?.guid || ''
  }

  @Type(() => FreightOrder)
  order?: FreightOrder

  @Type(() => Pallet)
  pallet?: Pallet
}
